export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/50 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/40 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 精彩不断</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
              漫蛙漫画
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-2">
                免费韩漫日漫国漫大全
              </span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg max-w-xl mx-auto lg:mx-0 leading-relaxed mb-4">
              海量热门漫画一网打尽，无论你钟爱韩漫的细腻画风、日漫的经典叙事，还是国漫的原创魅力，
              漫蛙漫画网都为你提供高清流畅的在线阅读体验。
            </p>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              每日同步更新热门连载，完结经典随时重温。新番速递、独家推荐、人气榜单实时刷新，
              让找漫画变得更简单。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-book-open-line text-primary-500 text-lg"></i>
                <span><strong className="text-foreground-800">20000+</strong> 漫画资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-timer-line text-primary-500 text-lg"></i>
                <span><strong className="text-foreground-800">每日</strong> 同步更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-primary-500 text-lg"></i>
                <span><strong className="text-foreground-800">高清</strong> 无广告阅读</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg"></i>
                开始探索
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                人气榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px]">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20illustration%20of%20manga%20reading%20scene%2C%20colorful%20comic%20panels%20floating%20in%20air%2C%20warm%20orange%20and%20coral%20tones%2C%20creative%20atmosphere%2C%20stylized%20digital%20art%20with%20soft%20gradients%2C%20manga%20characters%20in%20dynamic%20poses%2C%20whimsical%20storytelling%20vibe%2C%20clean%20background%20with%20gentle%20glow%20effects%2C%20reading%20and%20imagination%20theme&width=960&height=720&seq=hero-manga-01&orientation=landscape"
                  alt="漫蛙漫画 - 免费韩漫日漫国漫在线阅读平台"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-background-50 font-heading text-2xl font-black leading-none">20K+</div>
                  <div className="text-background-50/80 text-xs mt-1">漫画资源</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}